import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=3ecdfe81&scoped=true"
import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Popover.vue?vue&type=style&index=0&id=3ecdfe81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdfe81",
  null
  
)

export default component.exports